/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step4_ArtifactInputs */

const en_dr_step4_artifact = /** @type {(inputs: Dr_Step4_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each participant writes ≥3 cards alone, hidden, then everyone reveals at once`)
};

const id_dr_step4_artifact = /** @type {(inputs: Dr_Step4_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap peserta menulis ≥3 kartu sendiri, tersembunyi, lalu semua reveal serentak`)
};

/**
* | output |
* | --- |
* | "Each participant writes ≥3 cards alone, hidden, then everyone reveals at once" |
*
* @param {Dr_Step4_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step4_artifact = /** @type {((inputs?: Dr_Step4_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step4_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step4_artifact(inputs)
	return en_dr_step4_artifact(inputs)
});